import { render, staticRenderFns } from "./FlappyDecor.vue?vue&type=template&id=370bae93&"
import script from "./FlappyDecor.vue?vue&type=script&lang=ts&"
export * from "./FlappyDecor.vue?vue&type=script&lang=ts&"
import style0 from "./FlappyDecor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports